<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'settlement.wholesale.businessreasoncode' | translate }}</label>
    <select appSelect [collection]="businessReasonCodeList" formControlName="businessReasonCode">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.wholesale.chargetype' | translate }}</label>
    <select appSelect [collection]="chargeTypeList" formControlName="chargeType">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.wholesale.chargetypeid' | translate }}</label>
    <input type="text" appInput formControlName="chargeTypeId" [placeholder]="'settlement.wholesale.chargetypeid' | translate">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.wholesale.balancesupplier' | translate }}</label>
    <select appSelect [collection]="balanceSupplierList" formControlName="balanceSupplier">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.date.start' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.date.end' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
